import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty, toConsumableArray as _toConsumableArray, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { HttpStatus } from './constants.js';

var ApiError = /*#__PURE__*/function () {
  function ApiError(response, status) {
    var _this = this;

    _classCallCheck(this, ApiError);

    _defineProperty(this, "status", void 0);

    _defineProperty(this, "response", void 0);

    _defineProperty(this, "format", function () {
      var omitCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var overrideMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof _this.response === "string" && _this.response.length > 0) {
        return [_this.response];
      } // takes an error message/code/data, shows only message if omitCodes=true
      // [{ code: 3, message: "foo", data: ["more", "details"] }];
      // becomes ["foo (more, details) [3]"];
      // [{ code: 3, message: "foo"}];
      // becomes ["foo [3]"];


      var prettyError = function prettyError(error) {
        var message = error.message,
            data = error.data,
            code = error.code;
        var messageStr = message !== undefined && overrideMessages.hasOwnProperty(message) ? overrideMessages[message] : code !== undefined && overrideMessages.hasOwnProperty(code) ? overrideMessages[code] : message;

        if (typeof messageStr === "function") {
          messageStr = messageStr(error);
        }

        if (typeof messageStr === "string") {
          var dataStr = typeof data === "string" ? " (".concat(data, ")") : Array.isArray(data) ? " (".concat(data.join(", "), ")") : "";
          var codeStr = omitCodes || code === null || code === undefined ? "" : " [".concat(code, "]");
          return "".concat(messageStr).concat(dataStr).concat(codeStr);
        }

        return /*#__PURE__*/ /*#__PURE__*/React.isValidElement(messageStr) ? messageStr : null;
      };

      if (Array.isArray(_this.response)) {
        return _this.response.reduce(function (acc, e) {
          var msg = prettyError(e);
          return msg ? [].concat(_toConsumableArray(acc), [msg]) : acc;
        }, []);
      }

      if (_typeof(_this.response) === "object") {
        var msg = prettyError(_this.response);
        return msg ? [msg] : [];
      }

      return [];
    });

    this.status = status !== undefined ? status : HttpStatus.InternalServerError;
    this.response = response;
  }

  _createClass(ApiError, [{
    key: "message",
    get: function get() {
      var messages = this.format();
      return messages.length > 0 ? messages.join(" / ") : "An unexpected error has occurred";
    }
  }]);

  return ApiError;
}();

export { ApiError };
